import { ApiLink } from '@mkp/shared/models';
import { mapAuditDates } from '@mkp/shared/data-access';
import { Location, LocationDto, LocationPatchBody } from '@mkp/location/models';

export const mapLocationDtoToLocation = (dto: LocationDto): Location => {
  const { _embedded, _type, ...rest } = dto;
  return {
    ...rest,
    ...mapAuditDates(dto),
    _links: Object.values(dto._links).filter(Boolean) as ApiLink[],
  };
};

export const mapLocationToLocationRequestBody = (location: Location): LocationPatchBody => ({
  companyProfileId: location.companyProfileId,
  address: location.address,
  _version: location._version,
});
